import * as coreCommon from 'assets/core/js/common'

export default function (form: HTMLFormElement): void {
  document.querySelector<HTMLFormElement>('.product__reviews-content form')?.scrollIntoView({
    block: 'start',
    inline: 'nearest',
    behavior: 'smooth',
  })

  const sortPageEl = document.getElementById('reviews_sort_page') as HTMLInputElement
  const sortSortEl = document.getElementById('reviews_sort_sort') as HTMLInputElement
  const sortGoToPageEl = document.getElementById('reviews_sort_goToPage') as HTMLInputElement

  if (!sortPageEl || !sortSortEl || !sortGoToPageEl) {
    return
  }

  const currentPage = sortPageEl.value || 1

  const data = [
    `reviews_sort[sort]=${encodeURIComponent(sortSortEl.value)}`,
    `reviews_sort[page]=${currentPage}`,
    `reviews_sort[goToPage]=${encodeURIComponent(sortGoToPageEl.value)}`,
  ]

  const sortPreviousPageEl = document.getElementById('reviews_sort_previousPage') as HTMLInputElement
  const sortNextPageEl = document.getElementById('reviews_sort_nextPage') as HTMLInputElement

  if (sortPageEl) {
    data.push(`reviews_sort[previousPage]=${encodeURIComponent(sortPreviousPageEl.value)}`)
  }

  if (sortPreviousPageEl.value) {
    data.push(`reviews_sort[previousPage]=${encodeURIComponent(sortPreviousPageEl.value)}`)
  }

  if (sortNextPageEl.value) {
    data.push(`reviews_sort[nextPage]=${encodeURIComponent(sortNextPageEl.value)}`)
  }

  const xhr = coreCommon.createXhr('GET', `${form.getAttribute('action')}?${data.join('&')}`)

  const loadingEl = document.querySelector<HTMLElement>('.reviews__loading')
  const reviewsListEl = document.querySelector<HTMLElement>('.product__reviews-content .reviews__list')

  if (!loadingEl || !reviewsListEl) {
    return
  }

  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
      const content = xhr.response as string
      reviewsListEl.outerHTML = content
      loadingEl.style.display = 'none'
    }
  }

  xhr.send(null)

  reviewsListEl.innerHTML = ''
  loadingEl.style.display = 'block'
}
